import React from 'react';
import { ClockIcon, LayersIcon, FileTextIcon, GiftIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function MetricsBar() {
  const metrics = [{
    icon: <ClockIcon className="w-6 h-6 md:w-8 md:h-8 text-kid-purple" data-id="element-223" />,
    number: '10',
    label: 'Minutos diarios',
    bg: 'bg-kid-purple/10',
    border: 'border-kid-purple/20'
  }, {
    icon: <LayersIcon className="w-6 h-6 md:w-8 md:h-8 text-kid-pink" data-id="element-224" />,
    number: '3',
    label: 'Etapas del método',
    bg: 'bg-kid-pink/10',
    border: 'border-kid-pink/20'
  }, {
    icon: <FileTextIcon className="w-6 h-6 md:w-8 md:h-8 text-kid-lime" data-id="element-225" />,
    number: '200+',
    label: 'Actividades imprimibles',
    bg: 'bg-kid-lime/10',
    border: 'border-kid-lime/20'
  }, {
    icon: <GiftIcon className="w-6 h-6 md:w-8 md:h-8 text-kid-sky" data-id="element-226" />,
    number: '7',
    label: 'Bonos incluidos',
    bg: 'bg-kid-sky/10',
    border: 'border-kid-sky/20'
  }];
  return <section className="py-6 md:py-12 px-4 bg-white relative z-10 border-t border-gray-100" data-id="element-227">
      <div className="max-w-6xl mx-auto" data-id="element-228">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6" data-id="element-229">
          {metrics.map((metric, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-230">
              <div className={`flex flex-col items-center text-center p-4 md:p-6 rounded-xl ${metric.bg} border ${metric.border} shadow-sm`} data-id="element-231">
                <div className="mb-2 md:mb-3" data-id="element-232">{metric.icon}</div>
                <span className="text-2xl md:text-4xl font-bold text-gray-900 mb-0.5 md:mb-1" data-id="element-233">
                  {metric.number}
                </span>
                <span className="text-[11px] md:text-sm text-gray-500 font-medium" data-id="element-234">
                  {metric.label}
                </span>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}